import { Link } from "@tanstack/react-router";
import { BadgeCheck } from "lucide-react";
import { SITE } from "@/content/site";
import portrait from "@/assets/tamal-portrait-photo.webp?w=192&format=webp";

/** "Written by" author row at the top of English articles. */
export function ArticleByline() {
  return (
    <div className="mt-10 flex items-start gap-4 pb-10 border-b border-border">
      <img
        src={portrait}
        alt={`${SITE.fullName}, SEO expert in ${SITE.city}, ${SITE.country}`}
        width={56}
        height={56}
        loading="lazy"
        className="size-14 rounded-full object-cover shrink-0"
      />
      <div className="flex-1 min-w-0">
        <div className="flex flex-wrap items-center gap-x-2 gap-y-1 text-sm font-medium">
          <span className="text-muted-foreground">Written by</span>
          <Link to="/about" rel="author" className="hover:text-primary">
            {SITE.fullName}
          </Link>
          <span className="inline-flex items-center gap-1 rounded-full border border-primary/40 bg-primary/10 px-2 py-0.5 text-[10px] uppercase tracking-[0.18em] text-primary">
            <BadgeCheck size={10} /> Author profile
          </span>
        </div>
        <p className="mt-1.5 text-xs text-muted-foreground leading-relaxed">
          SEO, AEO &amp; GEO consultant based in {SITE.city}, {SITE.country}. Technical SEO, local
          search and content strategy. <Link to="/about" className="text-primary underline-offset-4 hover:underline">Full bio →</Link>
        </p>
      </div>
    </div>
  );
}
